"use client";

import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

interface DoralHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function DoralHero({ h1, subhead, zips }: DoralHeroProps) {
  const { t, currentLang } = useLanguage();

  return (
    <section className="relative flex flex-col lg:flex-row min-h-[70vh]">
      <div className="lg:w-1/2 relative overflow-hidden">
        <img
          src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/3a196f5b-16d5-49d8-9712-dd9929beab7f_impact-windows-doral.jpg?v=f3f5fa37903130056bb819dff7a6db8a"
          alt={currentLang === "es" ? "Reparación de ventanas en Doral Miami" : "Window repair in Doral Miami"}
          className="w-full h-full object-cover"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = "https://placehold.co/800x700/064e3b/ffffff";
          }}
        />
      </div>
      <div className="lg:w-1/2 bg-white flex items-center px-8 py-14 lg:px-12 lg:py-16">
        <div className="max-w-lg">
          <span className="text-[#ea580c] text-xs font-bold uppercase tracking-[0.2em] mb-4 block">
            {currentLang === "es" ? "Reparación de Ventanas Doral" : "Doral Window Repair"}
          </span>
          <h1 className="text-4xl lg:text-5xl font-extrabold uppercase text-[#064e3b] mb-6 leading-tight">
            {h1 || t("doral.h1")}
          </h1>
          <p className="text-base text-gray-700 mb-8 leading-relaxed">
            {subhead || t("doral.subhead")}
          </p>
          {zips && zips.length > 0 && (
            <p className="text-xs text-gray-500 mb-6">
              {t("hood.zipCodes")}{zips.join(", ")}
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center justify-center bg-[#ea580c] text-white px-8 py-3.5 font-bold uppercase text-sm whitespace-nowrap hover:bg-[#c2410c] transition-colors"
            >
              <i className="ri-phone-line mr-2" />
              {t("hood.callNow")}
            </a>
            <Link
              to="/contact/"
              className="inline-flex items-center justify-center border-2 border-[#064e3b] text-[#064e3b] px-8 py-3.5 font-bold uppercase text-sm whitespace-nowrap hover:bg-[#064e3b] hover:text-white transition-colors"
            >
              {t("hood.getQuote")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}